export default __webpack_public_path__ + "static/media/future-city-linear-template.3fe0a696.png";